import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../actions';
import { find } from 'lodash';
import SurveyPageWrapper from './SurveyPageWrapper';
import PaginationWrapper from './PaginationWrapper';
import LoadingState from './LoadingState';
import ErrorSection from './ErrorSection';
import { getLoadingTextFromLoadingType } from '../utils';

class MultiStepSurvey extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    let surveyId = notefit_config.survey_id;
    let eventId = notefit_config.event.id;
    this.props.fetchSurveyPage(eventId, surveyId, 0);
  }

  componentDidUpdate() {
    this.redirectLogic();
  }

  redirectLogic() {
    if(this.props.submitted) {
      window.location.href = window.location.href + "/confirmation";
    }
  }

  render() {
    const { surveyPages, surveyResponses, currentPage, totalPages, loading, error, validateCurrentPage, loadingType, submitted, submitError } = this.props;
    let currentSurveyResponse = find(surveyResponses, { 'surveyPagePosition': currentPage });
    let surveyCanBeModified = (!submitted && !loading && surveyPages.length > 0);
    return(
      <div>
        {validateCurrentPage &&
          <ErrorSection text={"Please answer questions"} />
        }
        {submitError &&
          <ErrorSection text={error} />
        }
        <div className="mt2 p3 mb-shadow-box">
          {(surveyCanBeModified) ? (
            <div>
              <SurveyPageWrapper surveyPage={surveyPages[currentPage]} surveyResponse={currentSurveyResponse} currentPage={currentPage} totalPages={totalPages} validateCurrentPage={validateCurrentPage} />
            </div>
          ) : (
            <LoadingState text={getLoadingTextFromLoadingType(loadingType)} loadingType={loadingType} />
          )
          }
        </div>
        <div className="mt3 mb3">
          <PaginationWrapper enabled={surveyCanBeModified} currentPage={currentPage} totalPages={totalPages} loading={loading} />
        </div>

      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

const mapStateToProps = state => ({
  surveyPages: state.surveyPages,
  surveyResponses: state.surveyResponses,
  currentPage: state.currentPage,
  totalPages: state.totalPages,
  loading: state.loading,
  loadingType: state.loadingType,
  error: state.error,
  validateCurrentPage: state.validateCurrentPage,
  submitted: state.submitted,
  submitError: state.submitError
});

export default connect(mapStateToProps, mapDispatchToProps)(MultiStepSurvey);
